// Format duration like LinkedIn: "Jul 2024 - Present" or "Jul 2024 - Dec 2024"
// The API now returns date strings instead of Unix timestamps
export const formatDate = (dateString, fallback = "") =>
  dateString
    ? new Date(dateString).toLocaleDateString("en-GB", {
        month: "short",
        year: "numeric",
      })
    : fallback;
